// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".72b01599152b50439f4802ef16ce37bb522fdd97.chunk.js";
};